export default __webpack_public_path__ + "static/Pack4Good-4a30f527c8bf94ad34c8f354a426c2c9.png";